module.exports = "https://www.ilove11.top/img/face45.4ac97da5.gif";